import i18n from "@/langs/i18n";

export function getAll() {
  return [
    {
      value: 0,
      name: "Text",
      text: `${i18n.t("option.elecInvoiceTitleType.Text")}`,
    },
    {
      value: 1,
      name: "Picture",
      text: `${i18n.t("option.elecInvoiceTitleType.Picture")}`,
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
